import { commonUtils } from '@/helpers/commonUtils'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import style from './StaffQr.module.less'

const StaffQr = observer(() => {
  return (
    <div className={classNames(style.contentBox)}>
      <p className={classNames(style.title)}>扫码添加客服</p>
      <p className={classNames(style.subTitle)}>您的专属客服，即将为您服务</p>
      <div className={classNames(style.qrBox)}>
        <img
          src={commonUtils.getStaticFile('dashboard/bg__qr.png')}
          className={classNames(style.qrBg)}
        />
        <img
          className={classNames(style.qrCode)}
          src='https://assets.weibanzhushou.com/web/pt-web/%E4%BC%9A%E8%AF%91-%E8%81%94%E7%B3%BB%E5%AE%A2%E6%9C%8D.126a016dd9f4.jpeg'
        />
      </div>
    </div>
  )
})

export default StaffQr
